import api from '@/utils/api'

export default {
    login(data) {
        return api.post('users/login', data)
    },
    getUsers(page, perPage, field, order) {
        const sort = (field && order) ? [field, order] : []
        const query = page && perPage && `sort=${JSON.stringify(sort)}&` +
            `range=${JSON.stringify([page - 1, perPage])}`
        return api.get(`users${query ? `?${encodeURI(query)}` : ''}`)
    },
    getCurrentUser() {
        return api.get('users/current')
    },
    deleteUser(id) {
        return api.delete(`users/${id}`)
    },
    getUserById(id) {
        return api.get(`users/${id}`)
    },
    createNewUser(user) {
        return api.post('users', user)
    },
    updateUser(user, id) {
        return api.put(`users/${id}`, user)
    }
}
